// Styles for DropdownMolecule go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { constants } from '../../modules';

export const StyledDropdown = styled.div<{ isModal?: boolean }>`
  margin-top: -${props => (props?.isModal ? toRem(16) : '0')};
  .dropdown {
    position: relative;

    background-color: ${baseVariables?.color?.base20};
    border-radius: ${toRem(8)};

    .dropdown-option-value {
      // adding custom styles here to override the styles of shared/mi-ui-library molecule
      padding-left: ${toRem(16)};
      // TO DO: this code is commented, due to arrow was overlapping in activity filter.
      /* position: absolute;
        right: ${toRem(16)}; */
    }
    &__disable {
      border: ${toRem(1)} solid ${baseVariables.color.neutral30} !important;
      pointer-events: none;
    }
    &__enable {
      border: ${toRem(1)} solid ${baseVariables.color.neutral40} !important;
    }

    &__error {
      border: ${toRem(1)} solid ${baseVariables.color.alert50} !important;
    }

    &__active {
      border: ${toRem(1)} solid ${baseVariables.color.base10} !important;
    }

    &__container {
      position: absolute;
      width: 100%;
      z-index: 3;
      top: ${toRem(42)};
      left: 0;
      .m-dropdown-container {
        border-radius: ${toRem(12)};
        box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 ${constants.BORDER10};
        .m-dropdown-content {
          border-radius: 0;
          max-height: max-content;
        }
      }
      &--list {
        list-style: none;
        &:focus {
          outline: none;
        }
        &--option {
          background: none;
          cursor: pointer;
          &.selected {
            font-weight: 600;
          }
          &.focused {
            border: ${toRem(2)} solid ${baseVariables.color.neutral00};
          }
          &:hover {
            background-color: ${baseVariables.color.neutral20};
          }
        }
      }
    }
  }
  .option-current {
    border: ${toRem(2)} solid ${baseVariables.color.neutral00};
  }

  .dropdown-labeled {
    cursor: pointer;
    border-radius: ${toRem(8)} !important;
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    color: ${baseVariables.color.base10};
    padding: ${toRem(24)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};

    .icon-dropdown-down,
    .icon-dropdown-up {
      position: absolute;
      right: 0;
      bottom: ${toRem(6)};
      font-size: ${toRem(24)};
    }
    .dropdown-value {
      font-size: ${toRem(14)};
      line-height: ${toRem(21)};
      &:is(${constants.HINDI_LANG}) {
        line-height: ${toRem(25)};
      }
      font-weight: ${baseVariables.font['fontWeightRegular']};
    }

    .dropdown__container {
      top: ${toRem(52)};
      color: ${baseVariables.color['neutral40']} !important;
      z-index: 99;
    }
  }
  .dropdown {
    &__label {
      font-weight: ${baseVariables.font['fontWeightRegular']};
      z-index: 1;
      position: absolute;
      top: ${toRem(7)};
      left: ${toRem(24)};

      &--text {
        position: relative;
        display: flex;
        justify-content: space-between;
        width: inherit;
        top: ${toRem(8)} !important;

        .icon-dropdown-down:before {
          top: unset;
          bottom: ${toRem(8)} !important;
        }
      }
    }
  }
  .option-disabled {
    color: ${baseVariables.color['neutral30']} !important;
  }
  .dropdown-showBothOptions {
    width: max-content;
    min-width: 100%;
  }

  .dropdown-value {
    overflow: hidden;
    text-overflow: ellipsis;
    &__standard {
      margin-right: ${toRem(16)};
    }
  }
  .dropdown__label {
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
